var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-tree p-0 h-fit overflow-hidden",attrs:{"id":"document-move-dialog-foldertreelist"}},[_c('tree-template',{attrs:{"folder":{
      name: _vm.vesselName,
      path: _vm.selectedItemId,
      isOpen: _vm.isOpen
    },"switchOpenMethod":_vm.toggleSwitchOpen,"selectedMethod":_vm.toggleTreeSelect,"isSelected":_vm.isSelected},scopedSlots:_vm._u([{key:"child",fn:function(){return [_c('folder-tree-item',{attrs:{"folders":_vm.moveDialogFolders,"validate":_vm.validate}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }